import { callOrganizationServiceApi } from '../../../apis/organizationService';

/**
 * Every identity with access to one location, direct or inherited, from
 * organization-service. The location is addressed by the monolith office id
 * (`registermodelId`), so the office profile can call it with the id it
 * already has. One response, no paging.
 *
 * @param {string} officeId - The office's monolith id
 * @returns {Promise<import('../types/Identity.api').IGetLocationIdentitiesApiResponse>}
 */
export const getLocationIdentities = (officeId) =>
  callOrganizationServiceApi('get', 'admin/identities', {
    params: { registermodelId: officeId },
  });
